























































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import IStampOutput from "@/api/models/IStampOutput";
import VDelete from "../components/VDelete.vue";
import SwitchButton from "@/components/SwitchButton.vue";
import { EnvironmentMixin } from "@/helpers/environment-mixin";
import VPreview, { PreviewAction } from "../components/VPreview.vue";
import { Company } from "@/api/company-api";
import { User } from "@/api/user-api";

@Component({
  components: {
    VDelete,
    SwitchButton,
    VPreview
  }
})
export default class StampEdit extends Mixins<EnvironmentMixin>() {
  @Prop({ required: true }) stamp!: IStampOutput;
  @Prop({ required: true }) isEdit!: boolean;
  @Prop({ required: true }) company!: Company;

  status = "";

  get user(): User {
    return this.$store.state.user;
  }

  ok() {
    if (!this.isEdit) {
      if (!(this.$refs.icon as HTMLInputElement).value) {
        alert("画像ファイルを選択してください");
        return;
      }
    }

    this.status = "progressing";
    this.$emit("ok");
  }

  cancel() {
    this.$emit("cancel");
  }

  remove() {
    this.$emit("remove");
  }

  handleIconChange(e: Event) {
    const listType = ["image/png", "image/gif"];
    const files = (e.target as HTMLInputElement).files;
    if (!files || !files[0]) return;

    if (!listType.includes(files[0].type)) {
      alert("imageにはpng, gifタイプのファイルを指定してください。");
      return;
    }

    const url = URL.createObjectURL(files[0]);
    this.stamp.icon = url;

    this.$emit("updateIcon", e);
  }
  get previewActions(): PreviewAction[] {
    return [];
  }
  preview() {
    (this.$refs.preview as VPreview).show();
  }
}
